import { motion, AnimatePresence } from "framer-motion";
import { X, Music, Film } from "lucide-react";
import { mediaUrl, thumbUrl } from "@/lib/api";
import { useMediaHold } from "@/lib/scroll";

export default function MediaModal({ item, onClose }) {
  useMediaHold(!!item);
  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={onClose}
          data-testid="media-player-modal"
        >
          <motion.div
            initial={{ y: 40, opacity: 0, scale: 0.97 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 40, opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="bg-elevate border border-white/15 w-full max-w-3xl p-6 sm:p-8 clip-frame"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 mb-6">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-blood mb-2 flex items-center gap-2">
                  {item.kind === "video" ? <Film size={12} /> : <Music size={12} />}
                  Now Playing — {item.kind}
                </p>
                <h3 className="font-display font-bold uppercase text-xl sm:text-2xl">{item.title}</h3>
              </div>
              <button
                data-testid="media-player-close-button"
                onClick={onClose}
                className="text-gray-400 hover:text-blood transition-colors"
                aria-label="Close player"
              >
                <X size={24} />
              </button>
            </div>

            {item.kind === "video" ? (
              <video
                data-testid="media-player-video"
                src={mediaUrl(item.storage_path)}
                poster={item.thumbnail_path ? thumbUrl(item.thumbnail_path) : undefined}
                controls
                autoPlay
                className="w-full max-h-[60vh] bg-black"
              />
            ) : (
              <>
                {item.thumbnail_path && (
                  <img
                    src={thumbUrl(item.thumbnail_path)}
                    alt={item.title}
                    data-testid="media-player-cover"
                    className="w-full max-h-[50vh] object-cover mb-4 clip-frame"
                  />
                )}
                <audio
                  data-testid="media-player-audio"
                  src={mediaUrl(item.storage_path)}
                  controls
                  autoPlay
                  className="w-full"
                />
              </>
            )}

            {item.description && (
              <p className="mt-6 text-sm text-gray-400 leading-relaxed">{item.description}</p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
